import React from 'react';
import { PropTypes } from 'prop-types';
import { image } from 'constants';

const propTypes = {
  imageFile: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

const defaultProps = {
  imageFile: undefined,
  width: '75',
  height: '75',
};

const httpRegex = /(http(s?)):\/\//gi;

const getProfileImage = imageFile =>
  httpRegex.test(imageFile)
    ? imageFile
    : `${image.baseUrl}${imageFile}?template=size150x150face`;

const ProfileImage = ({
  imageFile,
  className = 'profile-image',
  width,
  height,
}) => (
  <span className={className}>
    <img
      src={imageFile ? getProfileImage(imageFile) : image.defaultAvatar}
      alt="Profile"
      width={width}
      height={height}
    />
  </span>
);

ProfileImage.propTypes = propTypes;
ProfileImage.defaultProps = defaultProps;

export default ProfileImage;
